import React, { useContext } from 'react';
import { CONFIG } from 'config/config';
import { PickerHOC, NavigationWrapper } from '@coinscrap/webapp-core';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { AgentContext } from '../../../contexts/agent';

export const Rastreator = PickerHOC(
	{},
	LoadingScreen,
)(() => {
	const { setRastreatorValues } = useContext(AgentContext);
	const { navigateTo } = NavigationWrapper.use();
	setRastreatorValues();
	CONFIG.routing.personalized.next(navigateTo, 'rastreator');

	return <></>;
});
